// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--bGKdR","title":"a10a3f92e9--title--UcZpc","text":"a10a3f92e9--text--pVeCF"};